import React from 'react';
import { Avatar } from 'antd';
import FloatingAccountBubble from '@/components/FloatingAccountBubble';

interface HeaderProps {
	title?: string;
	debrand?: boolean;
	icon?: React.ReactNode;
	description?: string;
}

const Header: React.FC<HeaderProps> = ({
	title = 'Hey! I am your AI Receptionist',
	debrand = false,
	icon,
	description,
}) => {
	return (
		<div className="p-2 sm:p-3 mt-0 mb-0 bg-gradient-to-br from-[#667eea] to-[#764ba2] rounded-b-[20px] relative overflow-hidden">
			{/* Background decoration */}
			<div className="absolute -top-1/2 -right-1/5 w-[300px] h-[300px] bg-white/10 rounded-full blur-[60px]" />
			<div className="absolute -bottom-1/3 -left-1/10 w-[200px] h-[200px] bg-white/5 rounded-full blur-[40px]" />

			<div className="relative">
				<div className="flex flex-col lg:flex-row items-start md:items-center justify-between gap-3 md:gap-0">
					<div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full md:w-auto">
						{icon && (
							<Avatar
								size={{ xs: 28, sm: 48, md: 88 }}
								className="hidden sm:flex bg-white/20 border-[2px] border-white/30 text-[14px] sm:text-[16px] md:text-[22px] font-semibold text-white backdrop-blur-[10px] w-8 h-8 sm:w-12 sm:h-12 md:w-[70px] md:h-[70px] items-center justify-center"
							>
								{icon}
							</Avatar>
						)}
						<div className="w-full sm:w-auto">
							<h1 className="text-[20px] sm:text-[24px] md:text-[28px] font-extrabold text-white m-0 leading-tight tracking-[-0.5px] mb-0">
								{title}
							</h1>
							{description && (
								<p className="hidden sm:block text-white/80 mt-0.5 text-sm sm:text-base mb-0">
									{description}
								</p>
							)}
						</div>
					</div>
					<div className="hidden md:block w-full md:w-auto !bg-gray-100 !rounded-2xl shadow-sm p-3 sm:p-4 cursor-pointer hover:bg-gray-200 transition-all duration-300 border border-gray-200">
						<FloatingAccountBubble debrand={debrand} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Header;
